import styled, { css } from 'styled-components';

import { grey } from '../../theme/colors';
import { sizes } from '../../theme/sizes';

interface Props {
  mbSize?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | 'auto' | 'initial';
  mtSize?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | 'auto' | 'initial';
  mlSize?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | 'auto' | 'initial';
  mrSize?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | 'auto' | 'initial';
}

const common = css<Props>`
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  padding: 0;
  margin: 0;
  color: ${grey.haydenGreyShade1};

  ${({ mbSize }) =>
    mbSize &&
    css`
      margin-bottom: ${sizes[mbSize]};
    `};

  ${({ mtSize }) =>
    mtSize &&
    css`
      margin-top: ${sizes[mtSize]};
    `};

  ${({ mlSize }) =>
    mlSize &&
    css`
      margin-left: ${sizes[mlSize]};
    `};

  ${({ mrSize }) =>
    mrSize &&
    css`
      margin-right: ${sizes[mrSize]};
    `};
`;

export const H1 = styled.h1<Props>`
  ${common}
  font-size: 24px;
  line-height: 28px;
  font-weight: 500;
`;

export const H2 = styled.h2<Props>`
  ${common}
  font-size: 20px;
  line-height: 26px;
  font-weight: 600;
`;

export const H3 = styled.h3<Props>`
  ${common}
  font-size: 16px;
  line-height: 18px;
  font-weight: 600;
`;
